import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { styled } from '@mui/system';
import AlertSnackbar from '../../AlertaUsuario';

const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;


interface ChangePasswordModalProps {
  open: boolean;
  handleClose: () => void;
  handleChangePassword: (currentPassword: string, newPassword: string) => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ open, handleClose, handleChangePassword }) => {
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');

  const handleCloseAlert = () => setAlertOpen(false);

  const handleSave = () => {
    if (currentPassword === "") {
      showAlert('Senha atual não informada.');
    } else if (newPassword === currentPassword) {
      showAlert('A nova senha não pode ser igual a senha atual.');      
    } else if (newPassword !== confirmPassword) {
      showAlert('A nova senha e a confirmação não coincidem.');
    } else if (solicitarSenhaSegura()) {
      handleChangePassword(currentPassword, newPassword);
      handleClose();
    }
  };

  const showAlert = (message: string) => {
    setAlertMessage(message);
    setAlertOpen(true);
  }

  const solicitarSenhaSegura = () => {
    const requisitos = [
      { regex: /.{8,}/, mensagem: "A senha deve ter pelo menos 8 caracteres." },
      { regex: /[A-Z]/, mensagem: "A senha deve conter pelo menos uma letra maiúscula." },
      { regex: /[a-z]/, mensagem: "A senha deve conter pelo menos uma letra minúscula." },
      { regex: /[0-9]/, mensagem: "A senha deve conter pelo menos um número." },
      { regex: /[\W_]/, mensagem: "A senha deve conter pelo menos um caractere especial." },
    ];

    let senhaSegura = false;

    while (!senhaSegura) {
      const erros = requisitos
        .filter(req => !req.regex.test(newPassword))
        .map(req => req.mensagem);

      if (erros.length === 0) {
        senhaSegura = true;
        return true;
      } else {
        showAlert("Senha inválida:\n" + erros.join("\n"));
        return false;
      }
    }
  }

  return (
    <Box>
      <Modal open={open} onClose={handleClose}>
        <ModalBox>
          <Typography variant="h6">Alterar Senha</Typography>

          <TextField
            label="Senha Atual"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            fullWidth
          />

          <TextField
            label="Nova Senha"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
          />

          <TextField
            label="Confirmar Nova Senha"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
          />

          <Button variant="contained" color="primary" onClick={handleSave}>
            Salvar
          </Button>

        </ModalBox>
      </Modal>

      <AlertSnackbar
        open={alertOpen}
        onClose={handleCloseAlert}
        message={alertMessage}
        severity="error" // Define como erro, mas você pode personalizar
      />
    </Box>
  );
};

export default ChangePasswordModal;